import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios'
import config from '@/config.js'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
  state: {
    loading: false,
    documents: []
  },
  mutations: {
    loading(state, loading) {
      state.loading = loading
    },
    updateDocuments(state, documents) {
      state.documents = documents
    },
    addDocument(state, document) {
      state.documents.push(document)
    },
    deleteDocument(state, index) {
      state.documents.splice(index, 1)
    },
    saveDocument(state, document) {
      const index = state.documents.findIndex(d => d.id === document.id)
      state.documents[index] = document 
    },
  },
  actions: {
    async updateDocuments({commit}) {
      commit('loading', true)
      const response = await axios.get(`${config.apiUrl}/document`)
      const documents = response.data
      commit('updateDocuments', documents)
      commit('loading', false)
    },
    async addDocument({commit}) {
      const response = await axios.post(
        `${config.apiUrl}/document`
      )
      const document = response.data
      commit('addDocument', document)
    },
    async deleteDocument({commit, state}, index) {
      await axios.delete(
        `${config.apiUrl}/document/${state.documents[index].id}`
      )
      commit('deleteDocument', index)
    },
    async saveDocument({commit}, document) {
      await axios.patch(
        `${config.apiUrl}/document/${document.id}`,
        document
      )
      commit('saveDocument', document)
    },
  }
})
